export default "__VITE_ASSET__Ka91pJw9__"